import { createStore } from 'vuex'
import user from './modules/user'
import msg from './modules/msg'
import getters from './getters'

export default createStore({
  getters,
  modules: {
    getters,
    user,
    msg
  }
})
